<template>
  <div>
    <NBar title="收益详情" :top="true"/>
    <nut-tab ref="tab" @tab-switch="tabSwitch" :line-width="60" :def-index="tabDef">
      <nut-tab-panel tab-title="微信收益" style="background-color: #F5F6F8;">
        <nut-row :gutter="8" style="background-color: white;padding: 10px 0;margin-bottom: 10px;">
          <nut-col :span="8">
            <div @click="goStatus(0)" class="flex-content"
                 :style="{color:orderStatus === 0 ? '#194fff' : '#8f8f94',borderColor:orderStatus === 0 ? '#194fff' : '#8f8f94'}">
              全部
            </div>
          </nut-col>
          <nut-col :span="8">
            <div @click="goStatus(1)" class="flex-content"
                 :style="{color:orderStatus === 1 ? '#194fff' : '#8f8f94',borderColor:orderStatus === 1 ? '#194fff' : '#8f8f94'}">
              交易成功
            </div>
          </nut-col>
          <nut-col :span="8">
            <div @click="goStatus(2)" class="flex-content"
                 :style="{color:orderStatus === 2 ? '#194fff' : '#8f8f94',borderColor:orderStatus === 2 ? '#194fff' : '#8f8f94'}">
              退款
            </div>
          </nut-col>
        </nut-row>
        <list-loading ref="list0" :data.sync="list" :page.sync="page" :limit.sync="limit" @loadlist="getData"
                      :is-show-mod="true">
          <div slot="list" class="item" v-for="(item ,index) in list" :key="item.id">
            <nut-cell :to="`/device/OrderList?orderId=${item.orderId}`" :show-icon="true" style="padding: 10px;">
            <span slot="title" style="font-size: 16px;">
              <nut-price :price="item.payMoney" :needSymbol="false" :thousands="true"/>
              <span>元</span>
            </span>
              <span slot="sub-title">{{ item.payTime }}</span>
              <span slot="desc">订单详情</span>
            </nut-cell>
            <div class="content">
              <span>交易单号</span>
              <span>{{ item.thirdOrderId }}</span>
            </div>
            <div class="content">
              <span>订单号</span>
              <span>{{ item.orderId }}</span>
            </div>
          </div>
        </list-loading>
        <nut-backtop/>
      </nut-tab-panel>
      <nut-tab-panel tab-title="余额收益" style="background-color: #F5F6F8;">
        <nut-row :gutter="8" style="background-color: white;padding: 10px 0;margin-bottom: 10px;">
          <nut-col :span="8">
            <div @click="goStatus(0)" class="flex-content"
                 :style="{color:orderStatus === 0 ? '#194fff' : '#8f8f94',borderColor:orderStatus === 0 ? '#194fff' : '#8f8f94'}">
              全部
            </div>
          </nut-col>
          <nut-col :span="8">
            <div @click="goStatus(1)" class="flex-content"
                 :style="{color:orderStatus === 1 ? '#194fff' : '#8f8f94',borderColor:orderStatus === 1 ? '#194fff' : '#8f8f94'}">
              交易成功
            </div>
          </nut-col>
          <nut-col :span="8">
            <div @click="goStatus(2)" class="flex-content"
                 :style="{color:orderStatus === 2 ? '#194fff' : '#8f8f94',borderColor:orderStatus === 2 ? '#194fff' : '#8f8f94'}">
              退款
            </div>
          </nut-col>
        </nut-row>
        <list-loading ref="list1" :data.sync="list" :page.sync="page" :limit.sync="limit" @loadlist="getData"
                      :is-show-mod="true">
          <div slot="list" class="item" v-for="(item ,index) in list" :key="item.id">
            <nut-cell :to="`/device/OrderList?orderId=${item.orderId}`" :show-icon="true" style="padding: 10px;">
            <span slot="title" style="font-size: 16px;">
              <nut-price :price="item.payMoney" :needSymbol="false" :thousands="true"/>
              <span>元</span>
            </span>
              <span slot="sub-title">{{ item.payTime }}</span>
              <span slot="desc">订单详情</span>
            </nut-cell>
            <div class="content">
              <span>订单号</span>
              <span>{{ item.orderId }}</span>
            </div>
          </div>
        </list-loading>
        <nut-backtop/>
      </nut-tab-panel>
      <nut-tab-panel tab-title="充值收益" style="background-color: #F5F6F8;">
        <nut-row :gutter="8" style="background-color: white;padding: 10px 0;margin-bottom: 10px;">
          <nut-col :span="8">
            <div @click="goStatus(0)" class="flex-content"
                 :style="{color:orderStatus === 0 ? '#194fff' : '#8f8f94',borderColor:orderStatus === 0 ? '#194fff' : '#8f8f94'}">
              全部
            </div>
          </nut-col>
          <nut-col :span="8">
            <div @click="goStatus(1)" class="flex-content"
                 :style="{color:orderStatus === 1 ? '#194fff' : '#8f8f94',borderColor:orderStatus === 1 ? '#194fff' : '#8f8f94'}">
              交易成功
            </div>
          </nut-col>
        </nut-row>
        <list-loading ref="list2" :data.sync="list" :page.sync="page" :limit.sync="limit" @loadlist="getData"
                      :is-show-mod="true">
          <div slot="list" class="item" v-for="(item ,index) in list" :key="item.id">
            <nut-cell :to="`/device/RechargeOrderList?orderId=${item.orderId}`" :show-icon="true"
                      style="padding: 10px;">
            <span slot="title" style="font-size: 16px;">
              <nut-price :price="item.payMoney" :needSymbol="false" :thousands="true"/>
              <span>元</span>
            </span>
              <span slot="sub-title">{{ item.payTime }}</span>
              <span slot="desc">订单详情</span>
            </nut-cell>
            <div class="content">
              <span>交易单号</span>
              <span>{{ item.thirdOrderId }}</span>
            </div>
            <div class="content">
              <span>订单号</span>
              <span>{{ item.orderId }}</span>
            </div>
          </div>
        </list-loading>
        <nut-backtop/>
      </nut-tab-panel>
    </nut-tab>
  </div>
</template>

<script>
/**
 * 收益详情
 */
export default {
  name: 'EarningsDetail',
  props: ['deviceId', 'startTime', 'endTime', 'tab'],
  data() {
    return {
      tabDef: 0,
      //当前标签下标
      tabIndex: this.tab || 0,
      orderStatus: 0,
      query: {
        paid: -1,
        status: -1,
        payType: 'weixin'
      },
      page: 1,
      limit: 20,
      list: []
    }
  },
  activated() {
    this.$refs.tab.switchTab (this.tabIndex, this.$refs.tab.$el, false)
    //setTimeout (() => this.tabDef = this.tabIndex, 500)
    this.getData ()
  },
  methods: {
    getData() {
      switch (this.tabIndex) {
        case 0:
          this.query.payType = 'weixin'
          break
        case 1:
          this.query.payType = 'balance'
          break
        case 2:
          this.query.payType = 'recharge'
          break
      }
      let time1 = new Date (this.startTime.replace (/-/g, '/') + ' 00:00:00')
      let time2 = new Date (this.endTime.replace (/-/g, '/') + ' 23:59:59')
      let data = {
        startTime: time1.getTime () / 1000,
        endTime: time2.getTime () / 1000,
        payType: this.query.payType,
        page: this.page,
        limit: this.limit
      }
      if (!this.$util.isArrOrNull (this.$api.merId)) {
        data.merId = this.$api.merId
      }
      if (!this.$util.isArrOrNull (this.$api.user.merIds)) {
        data.merIds = this.$api.user.merIds
      }
      if (this.addressId != 0) {
        data.addressId = this.addressId
      }
      if (this.query.paid !== -1) {
        data.paid = this.query.paid
      }
      if (this.query.status !== -1) {
        data.status = this.query.status
      }
      this.$api.post ({
        url: '/device/api/device/order/earnings/list',
        data: data,
        loading: false
      }).then (res => {
        this.$refs['list' + this.tabIndex].setRes (res)
      })
    },
    tabSwitch: function (index, event) {
      this.tabIndex = index
      this.getData ()
    },
    goStatus(num) {
      this.orderStatus = num
      if (num === 0) {//全部
        this.query.paid = -1
        this.query.status = -1
      }
      if (num === 1) {//已支付
        this.query.paid = 1
        this.query.status = -1
      }
      if (num === 2) {//已退款
        this.query.paid = 1
        this.query.status = 2
      }
      this.getData ()
    }
  }
}
</script>

<style scoped>
>>> .nut-tab {
  user-select: none;
  padding: 0;
  border-bottom: none;
  border-left: none;
  border-right: none;
}

>>> .nav-bar {
  background-color: #194fff;
}

>>> .nut-tab-active a {
  color: #194fff;
}

>>> .nut-tab-item {
  padding: 0;
  background-color: #F5F6F8;
  border: none;
}

.flex-content {
  user-select: none;
  color: #8f8f94;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 5px 0;
  border: 1px solid #8f8f94;
}

.item {
  margin-bottom: 10px;
  background-color: white;
  padding-bottom: 10px;
}

.item .content {
  font-size: 14px;
  color: #848484;
  height: 30px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/device/home/EarningsDetail.vue